import { render, staticRenderFns } from "./autoresponderTemplateVariables.vue?vue&type=template&id=74c5e68e&scoped=true&"
import script from "./autoresponderTemplateVariables.vue?vue&type=script&lang=js&"
export * from "./autoresponderTemplateVariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5e68e",
  null
  
)

export default component.exports